import React from 'react';
import { AlertCircle } from 'lucide-react';

export const ErrorMessage = ({ message }) => {
  return (
    <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg mb-4 flex gap-3">
      <AlertCircle className="text-red-500 flex-shrink-0" size={20} />
      <p className="text-red-700 text-sm">{message}</p>
    </div>
  );
};
